import React from 'react';
import { useState } from 'react';
import storage from './Firebase';
function Upload() {
    const [image, setImage] = useState('');
    const upload = () => {
        if (image.name == null) {
            alert("Choose a file😢")
            return;
        }

        storage.ref(`uploaded/${image.name}`).put(image)
            .on("state_changed", alert("You have Successfully Uploaded your Notes✔\n It will be displayed in the website after being verified👍\nWith Regards-Imraan💖"), alert);


    }

    return (
        <div className="container-fluid">
            <div className="upload" >
            <center>
                <input type="file" onChange={(e) => { setImage(e.target.files[0]) }} />
                <button class="button-77" onClick={upload}>Upload</button>
                <h2 style={{fontFamily:"Hurricane, cursive",fontcolor:"blue"}}>Do mention your name and e-mail in the pdf </h2>
            </center>
            <br />
        </div >
        </div>
    );
}

export default Upload;